import posthog from 'posthog-js';
import { useEffect } from 'react';

import { useStore } from '../hooks/useStore';
import useTranslation from '../hooks/useTranslation';
import { useDialog } from '../hooks/useDialog';

import StepTemplate from '../components/StepTemplate';
import { Button } from '@/lib/components/ui/button';
import { CheckIcon } from 'lucide-react';

const CompleteStep = () => {
  const translations = useTranslation();
  const setShowDialog = useDialog((state) => state.setShowDialog);
  const partner = useStore((state) => state.partner);
  useEffect(() => {
    posthog.capture('Complete Step');
  }, []);

  return (
    <StepTemplate
      footer={
        <Button
          onClick={() => setShowDialog(false)}
          variant={'outline'}
          aria-label={translations['close']}
        >
          {translations['close']}
        </Button>
      }
    >
      <div className="flex flex-col items-center gap-4 mb-3">
        <CheckIcon
          size="70"
          color="white"
          className="bg-samsungBlue rounded-full p-3"
        />
        <h1 id="title" className="text-2xl font-bold">
          {translations.completeTitle}
        </h1>
      </div>
      <p id="subtitle" className="text-lg mb-8 text-center">
        {translations.completedDescription}
      </p>
    </StepTemplate>
  );
};

export default CompleteStep;
